export var TAB = 9;
export var ENTER = 13;
export var BACKSPACE = 8;
export var LEFT = 37;
export var UP = 38;
export var RIGHT = 39;
export var DOWN = 40;
export var COMMA = 188;



// WEBPACK FOOTER //
// ./src/keyboard.js